import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute() {
  const token = localStorage.getItem("text2sql_authToken");
  console.log("process.env.REACT_APP_BASE_PATH private",process.env.REACT_APP_BASE_PATH)
  return token ? <Outlet /> : <Navigate to={`/login`} replace />;
}

export function PublicRoute() {
  const token = localStorage.getItem("text2sql_authToken");
  console.log("process.env.REACT_APP_BASE_PATH public",process.env.REACT_APP_BASE_PATH)
  return token ? <Navigate to={"/"} replace /> : <Outlet />;
}
